import React from "react";
import NewsletterModal from "../../modals/NewsletterModal/NewsletterModal";
import { FaStar, FaCalendarAlt, FaLightbulb } from "react-icons/fa";

const Newsletter = () => {
  const dynamicSections = [
    {
      icon: <FaStar style={{ marginRight: "0.4rem" }} />,
      heading: "Highlights of the Month",
      items: [
        {
          title: "Annual Sports Day",
          description: "Our students participated with great enthusiasm!",
          link: "https://google.com",
        },
        {
          title: "Parent-Teacher Meeting",
          description: "A warm thank you to all the parents who attended.",
        },
      ],
    },
    {
      icon: <FaCalendarAlt style={{ marginRight: "0.4rem" }} />,
      heading: "Upcoming Events",
      items: [
        {
          title: "Independence Day Celebration",
          description: "Join us for a flag hoisting and cultural program.",
        },
        {
          title: "Field Trip",
          description: "Students will visit the science museum next Friday.",
        },
      ],
    },
    {
      icon: <FaLightbulb style={{ marginRight: "0.4rem" }} />,
      heading: "Reminders",
      items: [
        {
          title: "Submit Consent Forms",
          description: "Forms for the trip are due by August 5th.",
        },
        {
          title: "No Classes on August 15th",
          description:
            "School will be closed in observance of Independence Day.",
        },
      ],
    },
  ];

  return (
    <NewsletterModal
      title="Newsletter – July 2025"
      greeting="Hi Parents,"
      intro="Here's everything you need to know about this month at our school:"
      sections={dynamicSections}
      sender="Principal Radhika"
      createdOn="July 1, 2025"
    />
  );
};

export default Newsletter;
